// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".view-all[data-v-574a5545]:hover{opacity:.6;transition:all .6s}.new-image[data-v-574a5545]{width:-moz-fit-content;width:fit-content}.img-visual[data-v-574a5545]{position:absolute;background:#e8effc;width:100%;height:100%;top:20px;left:20px;bottom:-20px;right:-20px;border-radius:5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
